import { BASE_URL } from '@/services/api'
import {request, METHOD} from '@/utils/request'


let UPLOAD_WAIT_BACKGROUND= `${BASE_URL}/waitBackground/update`
let WAIT_BACKGROUND_LIST= `${BASE_URL}/waitBackground/getBackgroundList`

export async function updateWaitBackground(params) {
  return request(UPLOAD_WAIT_BACKGROUND, METHOD.POST,params,{
    headers: {'Content-Type': 'multipart/form-data'}
  })
}

export async function getWaitBackgroundList(params) {
  return request(WAIT_BACKGROUND_LIST, METHOD.POST,params)
}


export default {
  updateWaitBackground,
  getWaitBackgroundList,
}
